export interface iUsuario {
  activo: boolean;
  formaEnvio: boolean;
  mail: string;
  mostrar: boolean;
  nombre: string;
  rol: number;
  superadmin: boolean;
  temas: { [key: string]: iTema };
  uid?: string | "";
  escritura?: any | [];
  lectura?: any | [];
}

export interface iTema {
  notificacion: boolean;
  permiso: number;
}

export interface ITemas {
  temas: { [key: string]: iTema }[] | [];
}

export let mUsuario: iUsuario = {
  activo: false,
  formaEnvio: false,
  mail: "",
  mostrar: false,
  nombre: "",
  rol: 0,
  superadmin: false,
  temas: {},
  uid: "",
  escritura: [],
  lectura: [],
};
